import { defineComponent, onMounted } from 'vue';
import CampaignSettings from '@/presentation/components/campaign-settings/campaign-settings.vue';
import CampaignManagement from '@/presentation/components/campaign-management/campaign-management.vue';
import GeneralCode from '@/presentation/pages/general/general.code';

export default defineComponent({
	components: {
		CampaignSettings,
		CampaignManagement
	},
	setup: () => {
		const code = new GeneralCode();

		onMounted(code.mounted.bind(code));

		return {
			isLoading: code.isLoading
		};
	}
});
